import { Grid } from "@mui/material";
import { AutocompleteInput, FormDataConsumer, ReferenceInput, TextInput, required } from "react-admin";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { administrationRequests } from "api/administrationApi";
import { BULGARIA_COUNTRY_ID } from "utils/constants";

const BirthSection = () => (
  <Grid container spacing={2}>
    <FormDataConsumer>
      {({ formData }) => (
        <>
          <Grid item xs={12} md={4}>
            <ReferenceInput
              reference={administrationRequests.getCountriesSelect()}
              source="birthCountryId"
            >
              <AutocompleteInput
                filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                optionText="nameBg"
                label="Държава на раждане"
                validate={required("Задължително")}
                fullWidth
              />
            </ReferenceInput>
          </Grid>
          {formData.birthCountryId === BULGARIA_COUNTRY_ID ? (
            <Grid item xs={12} md={4}>
              <ReferenceInput
                reference={administrationRequests.getSettlementsSelect()}
                source="birthSettlementId"
                filter={{ showDistrictAndMunicipality: true, showPostalCode: true }}
              >
                <AutocompleteInput
                  filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
                  optionText="nameBg"
                  label="Населено място"
                  validate={required("Задължително")}
                  fullWidth
                />
              </ReferenceInput>
            </Grid>
          ) : (
            <Grid item xs={12} md={4}>
              <TextInput
                source="birthSettlement"
                label="Населено място"
                validate={required("Задължително")}
                fullWidth
              />
            </Grid>
          )}
          <Grid item xs={12} md={4}>
            <CustomDateInput
              source="birthDate"
              label="Дата на раждане"
              validate={required("Задължително")}
              noTime
              fullWidth
              required
            />
          </Grid>
        </>
      )}
    </FormDataConsumer>
  </Grid>
);

export default BirthSection;
